// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1At5T","boxTitle":"Qualiphy_boxTitle__2HlR1","box":"Qualiphy_box__F3w8n","toggleWrap":"Qualiphy_toggleWrap__1k-QJ"};